import React from 'react';
import { useAppConfig } from '../../context/AppConfigContext';
import { OperationalScreen } from './OperationalScreen';

/**
 * Gate del checkout PrestaShop (Patitas&co). Mientras el mapping de productos
 * Shopify→PrestaShop no cubra el catálogo, `runtime_controls.
 * prestashop_checkout_enabled` está OFF y esta pantalla sustituye al funnel
 * — antes el usuario recorría las 14 pantallas y chocaba con "productos no
 * disponibles" en el último clic (auditoría 2026-06-12). Se enciende desde
 * el admin sin redeploy. La ruta /admin no pasa por aquí.
 */
export const PrestaShopGateScreen: React.FC = () => {
  const { config, logoImage } = useAppConfig();
  const ops = config.runtime_controls;

  return (
    <OperationalScreen
      logoSrc={logoImage}
      logoAlt="Patitas&co"
      emoji="🍲"
      title={ops?.prestashop_disabled_title || 'Muy pronto en Patitas&co'}
      message={
        ops?.prestashop_disabled_message ||
        'Estamos terminando de preparar la comida natural en esta tienda. Mientras tanto puedes pedirla en miloylola.com.'
      }
    />
  );
};
